//
//
//
//
//
//

export default {
  props: ['event'],
  methods: {
  }
}
